import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-payslip',
  templateUrl: './payslip.component.html',
  styleUrls: ['./payslip.component.css']
})
export class PayslipComponent implements OnInit {

    
//Save Validation
submitted:boolean;
successfully:boolean;


//Edit Get Values
payrollColl:any=[];
payrollBO:any={};
payrollSummaryColl: any = [];
payrollSummaryBO:any={};
paynettotal: any = 0;

payearntotal: any = 0;
paydeducttotal: any = 0;

payrollearnColl: any = [];
payrolldeductColl: any = [];
payrolllineLOP: any = {};


leavedays: any = 0;
paiddays: any = 0;

empBO: any = {};

companyBO:any={};


@Input() payrollid:any=0;
@Input() empid: any = null
@Input() empname: any = null

@Output() emitData = new EventEmitter();

@Output() filterChanged = new EventEmitter<number>();


  companyType: string = "";


  constructor(private toastr: ToastrService,private appService: AppdataService,private activeModal: NgbActiveModal,
    private loginService: LoginserviceService, private confirmationDialogService: ConfirmationDialogService) {
      this.fnServiceChanges();
     }

  
  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnGetCompanyType();

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    this.fnGetCompanyType();
  }

  fnGetCompanyType() {
    if (this.loginService.userBO) {
      this.companyType = this.loginService.userBO.payrolltype;
     
    }
  }
  //Get 
  fngetPayrolldetails() {
    var data = {
    'empid':this.empid,
    'payrollid':this.payrollid         
    }
    this.appService.fngetPayRollByEmpid(data)
    .subscribe(
    (res)=>{                
        if (res.json().status === 200) {  
          console.log(res.json())

          var result= res.json().result;
          this.payrollColl = result[0];

   
          this.payrollSummaryColl = result[1]; 
          
          if (this.payrollSummaryColl.length > 0) {
            this.paynettotal = this.payrollSummaryColl[0].totalamount;  
            this.payearntotal = this.payrollSummaryColl[0].earningamount;  
            this.paydeducttotal = this.payrollSummaryColl[0].deductionamount;  
            
            this.payrollSummaryBO = this.payrollSummaryColl[0]

            this.paiddays = this.payrollSummaryBO.payabledays;

            this.leavedays=this.payrollSummaryBO.lopdaysmanual
          }

          this.payrollearnColl = [];

          for (let abo of this.payrollColl) {
            if (abo.earningamount > 0) {
              this.payrollearnColl.push(abo);  
            }                      
          }
         
          this.payrolldeductColl = [];

          for (let abo of this.payrollColl) {
            if (abo.deductionamount > 0) {
              this.payrolldeductColl.push(abo);
            }
          }

          if ( result[2].length > 0) {
            this.payrollBO = result[2][0];
          }

          if ( result[3].length > 0) {
            this.empBO = result[3][0];
            this.companyBO =this.empBO 
          }
        //   if ( result[4].length > 0) {
        //     this.companyBO = result[3][0];
        // }

          
           
          this.paiddays = this.paiddays - this.leavedays;
          

        }
        else {
          this.loginService.fnAPIError(res.json())
        }

    },
    (err)=>{          
    this.toastr.error('Error', err);
    })
  }



  public decline() {
    this.activeModal.close(false);
    }
    
  
  
  // Print Chrome
  fnPrintSlip(){


    let printContents, popupWin;

    printContents = document.getElementById('print-section').innerHTML;  
    
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`<body onload="window.print();window.close()">${printContents}</body>`);
  
    popupWin.document.close();
}


  



private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}





}
